<template>
  <LoadOnVisible v-on:intersected="loadChartData">
    <b-card no-body>
      <b-card-header class="px-3 py-2">
        <!-- title and subtitle -->
        <div>
          <b-card-title class="mb-1" title-tag="h6">
            Bulk Shipments To Approve
          </b-card-title>
        </div>

        <span
          class="border badge badge-transparent d-none d-sm-inline-block"
          right
          no-caret
          toggle-class="p-0 mb-25"
          size="sm"
          >these still need to be approved
        </span>
        <!-- datepicker -->
      </b-card-header>

      <b-card-body class="p-0 orders-listing">
        <div class="text-center" v-if="isLoadingChartData">
          <b-spinner
            variant="primary"
            class="m-5"
            style="height: 4rem; width: 4rem"
            label="Loading..."
          ></b-spinner>
        </div>
        <div v-else>
            <TableListing
              class="mt-0"
              moreCustom5Class="nopadinr"
              sticky-header
              :responsive="false"
              :fixed="false"
              head-variant="light"
              :hide-pagination-top-fields="true"
              :loading-page="isLoadingChartData"
              :items.sync="items"
              :showPaginationRow="false"
              :fields.sync="tableColumns"
              :bordered="false"
            >
              <template v-slot:cell(orderNumber)="data">
                <div><span>{{ data.item.orderNumber }}</span></div>
              </template>
              <template v-slot:cell(createDateTimeUtc)="data">
                <span
                  v-if="
                    data.item.createDateTimeUtc &&
                      !data.item.createDateTimeUtc.endsWith('Z')
                  "
                  >{{
                    (data.item.createDateTimeUtc + 'Z') | moment('MMM Do, h:mm a')
                  }}</span
                >
                <span v-else-if="data.item.createDateTimeUtc">{{
                  data.item.createDateTimeUtc | moment('MMM Do, h:mm a')
                }}</span>
              </template>
              <template v-slot:cell(expectedDateTimeUtc)="data">
                <span
                  v-if="
                    data.item.expectedDateTimeUtc &&
                      !data.item.expectedDateTimeUtc.endsWith('Z')
                  "
                  >{{
                    (data.item.expectedDateTimeUtc + 'Z') | moment('MMM Do')
                  }}</span
                >
                <span v-else-if="data.item.expectedDateTimeUtc">{{
                  data.item.expectedDateTimeUtc | moment('MMM Do')
                }}</span>
                <span v-else> - </span>
              </template>
              <template v-slot:cell(brandId)="data">
                <span
                  v-if="myBrands && myBrands.find(a => a.id == data.item.brandId)"
                  >{{ myBrands.find(a => a.id == data.item.brandId).name | truncate(15) }}</span
                >
                <span v-else>-</span>
              </template>
              <template v-slot:cell(warehouseId)="data">
                <span
                  v-if="myWarehouses && myWarehouses.find(a => a.id == data.item.warehouseId)"
                  >{{ myWarehouses.find(a => a.id == data.item.warehouseId).name }}</span
                >
                <span v-else>- ANY -</span>
              </template>
              <template v-slot:cell(id)="data">
                <router-link
                  class="btn btn-info ml-1 btn-sml"
                  :to="{
                    name: 'Warehouses.BulkShipments.View',
                    params: { id: data.item.id }
                  }"
                >
                  <i class="fa fa-eye"></i>
                </router-link>
              </template>
            </TableListing>
        </div>
      </b-card-body>
    </b-card>
  </LoadOnVisible>
</template>

<script>
import { myCommonDataMixin } from '@/helpers/utils/vueMixins.js';
import { TableListing, LoadOnVisible } from '@/views/components/custom';

export default {
  mixins: [myCommonDataMixin],
  components: {
    TableListing,
    LoadOnVisible
  },
  props: {
    brandId: {
      type: String,
      required: false,
      default: null
    },
    warehouseId: {
      type: String,
      required: false,
      default: null
    },
  },
  data() {
    return {
      tableOpts: {
        totalRows: 0,
        loadedAll: true
      },
      items: [],
      tableColumns: [
      { key: 'orderNumber', label: 'Order #', sortable: false },
      { key: 'brandId', label: 'Client', sortable: false },
      { key: 'warehouseId', label: 'From', sortable: false },
      //{ key: 'user', label: 'By User', sortable: false },
      { key: 'createDateTimeUtc', label: 'Created At', sortable: false },
      { key: 'expectedDateTimeUtc', label: 'Expected', sortable: false },
      { key: 'id', label: 'Action', sortable: false }
      ],
      isLoadingChartData: true
    };
  },
  created() {
    // subcomponent, do not call common data
  },
  computed: {
  },
  watch: {
    brandId: function(newVal) {
      this.loadChartData();
    },
    warehouseId: function(newVal) {
      this.loadChartData();
    }
  },
  methods: {
    loadChartData() {
      this.isLoadingChartData = true;
      this.$http
        .post('/api/common/manualShipments/listItems', {
          perPage: 50,
          page: 1,
          orderType: 'BulkShipment',
          orderStatus: 'Draft',
          sortBy: 'expectedDate',
          sortDesc: false,
          brandId: this.brandId,
          warehouseId: this.warehouseId
        })
        .then(resp => {
          this.isLoadingChartData = false;
          this.items = resp.data.items;
          this.tableOpts.totalRows = this.items.length;
        })
        .catch(err => {
          this.isLoadingChartData = false;
          this.items = [];
        });
    }
  },
  mounted() {
  }
};
</script>
